var Vue   = require('vue').default
var App   = require('./App')
var httpr = require('@syyx/httpr')
import './main.css'
// var data  = require('./test_data.js')
// test_data.js:
// module.exports = {
//   'url1' : { method : 'get', status : 200, value : { ... }, fn : function(c) { retunr [ 200, { ... } ] } },
//   'url2' : { method : 'post', status : 200, value : { ... }, fn : function(c) { retunr [ 200, { ... } ] } },
//   ...
// }

var app = new Vue({
    el      : '#app',
    render  : h => h(App),
    created : function() {
        // this.$httpr = httpr.init({}) // , data)
    }
})
